import Vue from 'vue'
import Vuex from 'vuex'
import moment from "moment";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        url:{
            service_name_auth: 'auth',
            service_name_user: 'user',
            version_number: 'v1',
        },

        user: null,
        token: null,

        invite_link: null,

        login_status: false,

        step_block: true,

        step_1_status: 2,
        step_2_status: 1,
        step_3_status: 1,
        step_4_status: 1,
    },
    mutations: {
        updateUser(state, userData) {
            state.user = userData.user
            state.token = userData.token

            localStorage.setItem('eblitz_user', JSON.stringify(userData.user))
            localStorage.setItem('eblitz_token', userData.token)

            axios.defaults.headers.common['Authorization'] = 'JWT ' + userData.token;
        },
        updateInviteLink(state, link) {
            state.invite_link = link
            localStorage.setItem('eblitz_invite-link', link)
        },
        updateStepStatus(state, stepData) {
            let eblitz_steps = JSON.parse(localStorage.getItem('eblitz_steps'))
            for (let i = 1; i <= 4; i++) {
                if (eblitz_steps['step_' + i + '_status']===2 &&stepData.status!==0) {
                    state['step_' + i + '_status'] = stepData.complete?3:1
                    eblitz_steps['step_' + i + '_status'] = stepData.complete?3:1
                    break
                }
            }
            for (let i = 1; i <= 4; i++) {
                if (stepData.step === i) {
                    state['step_' + stepData.step + '_status'] = stepData.status
                    eblitz_steps['step_' + stepData.step + '_status'] = stepData.status
                } else {
                    state['step_' + i + '_status'] = eblitz_steps['step_' + i + '_status']
                }
            }
            localStorage.setItem('eblitz_steps', JSON.stringify(eblitz_steps))
        },
        updateLoginStatus(state, status) {
            state.login_status = status
        },
        updateStepBlock(state, status) {
            state.step_block = status
        },
    },
    actions: {
        checkUser({commit}) {
            if (!(localStorage.getItem('eblitz_user')
                && localStorage.getItem('eblitz_token')
                && localStorage.getItem('eblitz_invite-link')
                && localStorage.getItem('eblitz_steps'))) {
                let eblitz_steps = {
                    step_1_status: 2,
                    step_2_status: 1,
                    step_3_status: 1,
                    step_4_status: 1,
                }
                localStorage.setItem('eblitz_steps', JSON.stringify(eblitz_steps))
                return
            }

            let userData = {
                user: JSON.parse(localStorage.getItem('eblitz_user')),
                token: localStorage.getItem('eblitz_token')
            }
            commit('updateUser', userData)

            commit('updateInviteLink', localStorage.getItem('eblitz_invite-link'))

            let stepData = {
                step: 0,
                status: 0
            }
            commit('updateStepStatus', stepData)

            commit('updateStepBlock', false)
        },

        async getInviteLink({commit,state}) {
            let params = {
                max_use: 10,
                date_expiration: moment().add(10, 'days').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
                test_mode: false
            }
            await axios.post('/'+state.url.service_name_auth+'/'+state.url.version_number+'/'+state.url.service_name_user+'/'+'invites', params).then(res => {
                commit('updateInviteLink', res.data.link)
            }).catch(err => {
                console.log(err.response.data)
            });
        },
        cleanSignupSteps({state}){
            state.step_1_status = 2
            state.step_2_status = 1
            state.step_3_status = 1
            state.step_4_status = 1

            let eblitz_steps = {
                step_1_status: 2,
                step_2_status: 1,
                step_3_status: 1,
                step_4_status: 1,
            }
            localStorage.setItem('eblitz_steps', JSON.stringify(eblitz_steps))

        },
        logout({state}){
            localStorage.removeItem('eblitz_user')
            localStorage.removeItem('eblitz_token')
            localStorage.removeItem('eblitz_invite-link')

            state.user = null
            state.token = null
            state.invite_link = null

            state.step_block= true

            state.login_status=true

            state.step_1_status = 2
            state.step_2_status = 1
            state.step_3_status = 1
            state.step_4_status = 1

            let eblitz_steps = {
                step_1_status: 2,
                step_2_status: 1,
                step_3_status: 1,
                step_4_status: 1,
            }
            localStorage.setItem('eblitz_steps', JSON.stringify(eblitz_steps))

        },
    },
    getters: {
        url: state => {
            return state.url;
        },
        user: state => {
            return state.user;
        },
        invite_link: state => {
            return state.invite_link;
        },
        login_status: state => {
            return state.login_status;
        },
        step_block: state => {
            return state.step_block;
        },
        step_1_status: state => {
            return state.step_1_status;
        },
        step_2_status: state => {
            return state.step_2_status;
        },
        step_3_status: state => {
            return state.step_3_status;
        },
        step_4_status: state => {
            return state.step_4_status;
        },
    }
})
